import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './components/Homepage';
import ScrollToTop from './components/ScrollToTop'; 

// Main Pages
import Services from './pages/Services';
import Products from './pages/Products';
import Innovation from './pages/Innovation';
import Blogs from './pages/Blogs';
import About from './pages/About';
import Contact from './pages/Contact';
import BlogDetail from './pages/BlogDetail';

// Dynamic Pages
import DynamicProduct from './pages/DynamicProduct';
import DynamicService from './pages/DynamicService';

// Product Category Pages
import BreadImprovers from './pages/BreadImprovers';
import Premixes from './pages/Premixes';
import ShelfLifeEnhancers from './pages/ShelfLifeEnhancers';
import Emulsifiers from './pages/Emulsifiers';
import LeavingAgents from './pages/LeavingAgents';
import SpecialtyEnzymes from './pages/SpecialtyEnzymes';
import OtherIngredients from './pages/OtherIngredients';
import QualityAssurance from './pages/QualityAssurance';

import './App.css';




function App() {
  // // 👇 Dynamically detect basename for localhost or production
  //  const basename =
  //    window.location.hostname === "localhost" ? "":"/enessa";
  return (
   <Router>
    <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/products" element={<Products />} />
          <Route path="/innovation" element={<Innovation />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog/:id" element={<BlogDetail />} />

          {/* Dynamic Pages */}
          <Route path="/products/:slug" element={<DynamicProduct />} />
          <Route path="/services/:slug" element={<DynamicService />} />

          {/* Product Category Pages */}
          <Route path="/products/bread-improvers" element={<BreadImprovers />} />
          <Route path="/products/premixes" element={<Premixes />} />
          <Route path="/products/shelf-life" element={<ShelfLifeEnhancers />} />
          <Route path="/products/emulsifiers" element={<Emulsifiers />} />
          <Route path="/products/leavening" element={<LeavingAgents />} />
          <Route path="/products/enzymes" element={<SpecialtyEnzymes />} />
          <Route path="/products/other-ingredients" element={<OtherIngredients />} />
          <Route path="/quality" element={<QualityAssurance />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
